const SEARCH = {
  TKWW_SEARCH: "tkww/search.json",//搜索
  REST_SEARCH: "rest/search",
  TOP_WORDS:"rest/topWords",//搜索熱詞
  TIME_LIST:"tkww/temporal-chain.json",//时间链
}
export default SEARCH